module.exports = __webpack_public_path__ + "img/kongres-logo.69a2c96d.png";